import React, { useState, useEffect, createContext, useContext } from "react";
import Api from "utils/api";
import { useAuth } from "./auth";
import { enums } from "global/enums";
import { decryptJSON } from "global/security";

const initDesignContextPropsState = {
  loading: false,
  design: [],
  setDesign: () => {},
};

const DesignContext = createContext(initDesignContextPropsState);

const useDesign = () => {
  return useContext(DesignContext);
};

const DesignProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [design, setDesign] = useState("");

  const getDesign = async () => {
    const { response } = await Api(
      `/${enums.ROLES[currentUser.role]}/getDesigns`,
      "get"
    );
    setLoading(false);

    if (response) {
      const decryptedData = decryptJSON(response.data);

      setDesign(decryptedData);
    }
  };

  const onLoad = () => {
    // getDesign();
    setDesign(currentUser);
  };

  useEffect(onLoad, []);

  return (
    <DesignContext.Provider
      value={{
        loading,
        design,
        setDesign,
      }}
    >
      {children}
    </DesignContext.Provider>
  );
};

export { DesignProvider, useDesign };
